const commonReplacements = {
    maxEmailCharacters: { maxCharacters: 35 },
    maxNameCharacters: { maxCharacters: 25 },
    maxCompanyCharacters: { maxCharacters: 25 },
    maxPhoneCharacters: { maxCharacters: 15 },
    maxCountryCodeCharacters: { maxCharacters: 3 },
    maxAddressCharacters: { maxCharacters: 40 },
};

export default commonReplacements;
